import { Outlet } from 'react-router';

export default function GlobalSearchLayout() {
  return (
    <div className='size-full desktop:w-[352px] flex-1 desktop:flex-none flex flex-col desktop:border-r desktop:border-neutral-300'>
      <Outlet />
    </div>
  );
}
